module.exports = __webpack_public_path__ + "img/cheatsheet.af4c27dc.jpg";